import {
  LOAD_CARDS,
  LOAD_PRINT_REQUESTS,
  ADD_PRINT_REQUEST,
  UPDATE_PRINT_REQUEST,
  DELETE_PRINT_REQUEST,
} from 'redux/action_types'

const print_requests = (state = {}, action) => {
  let newState
  switch (action.type) {
    case LOAD_PRINT_REQUESTS:
    case LOAD_CARDS:
      if (action.print_requests) {
        newState = action.print_requests.reduce((map, request) => {
          map[request.id] = request
          return map
        }, {})
        return newState
      } else {
        return state
      }


    case ADD_PRINT_REQUEST:
    case UPDATE_PRINT_REQUEST:
      return {
        ...state,
        [action.print_request.id]: action.print_request,
      }
    case DELETE_PRINT_REQUEST:
      newState = { ...state }
      delete newState[action.id]
      return newState
  
    default:
      return state
  }
}

export default print_requests
